import { QueryState } from "@/ds/custom/QueryState";
import { useSubscription } from "@/features/common/api/useSubscription";
import { PremiumRequired } from "@/features/common/components/PremiumRequired";
import type { FC, PropsWithChildren } from "react";

export interface SubscriptionGateProps extends PropsWithChildren {
	featureName: string;
	compact?: boolean;
}

export const SubscriptionGate: FC<SubscriptionGateProps> = props => {
	const {
		featureName,
		compact = false,
		children
	} = props;

	const subscription = useSubscription();

	return (
		<QueryState query={subscription}>
			{
				data => data.activeSubscription
					? children
					: <PremiumRequired featureName={featureName} compact={compact} />
			}
		</QueryState>
	);
};
